import { getDatesBetweenTwoDates, getDatesOfTimeUnit } from "helpers";
import { StatisticsDataItemProps } from "modules/financial";
import moment from "moment";

import { ChartRangeType } from "../constants";

export const getPreparedBarsData = ({
  dateRange,
  activeRangeType,
  barsData
}: {
  dateRange: [Date, Date];
  activeRangeType: ChartRangeType;
  barsData: StatisticsDataItemProps[];
}): number[] => {
  const getAmountsByDatesArray = (dateArrayByTimeUnit: string[]) => {
    return dateArrayByTimeUnit.map((date) => {
      const found = barsData.find(
        (item) => moment(item.date).format("YYYY-MM-DD") === date
      );

      return found ? found.value : 0;
    });
  };

  switch (activeRangeType) {
    case ChartRangeType.Week:
      return getAmountsByDatesArray(
        getDatesOfTimeUnit(7, moment(dateRange[0]), "days")
      );
    case ChartRangeType.Month:
      return getAmountsByDatesArray(
        getDatesOfTimeUnit(
          moment(dateRange[0]).daysInMonth(),
          moment(dateRange[0]),
          "days"
        )
      );
    case ChartRangeType.Year:
      return getAmountsByDatesArray(
        getDatesOfTimeUnit(12, moment(dateRange[0]).startOf("year"), "month")
      );
    case ChartRangeType.Custom:
      return getAmountsByDatesArray(
        getDatesBetweenTwoDates(dateRange[0], dateRange[1])
      );
    default:
      return [];
  }
};
